import { View, Text } from "@react-pdf/renderer";
import { formatMoney } from "infra/helpers/number";
import PDFEmptyTable from "./EmptyTable";
import { makePdfStyleSheet } from "./../styles";

export interface PDFHorizontalTableRow<T> {
  title: string;
  renderValue: (data: T) => string;
  shouldRender: (data: T) => boolean;
}

interface PDFHorizontalTableProps<T> {
  title?: string;
  rows: PDFHorizontalTableRow<T>[];
  data: T;
  totalRow?: number;
  totalRowTitle?: string;
}

function PDFHorizontalTable<T>({
  title,
  rows,
  data,
  totalRow,
  totalRowTitle,
}: PDFHorizontalTableProps<T>) {
  const styles = makePdfStyleSheet();
  if (!data) {
    return (
      <View>
        <PDFEmptyTable />
      </View>
    );
  }

  return (
    <View style={styles.horizontalTable}>
      <View>
        <Text style={styles.horizontalTableTitle}>{title}</Text>
      </View>

      <View>
        {rows.map((row, index) =>
          !row.shouldRender || row.shouldRender?.(data) ? (
            <View style={styles.horizontalTableRow} key={index}>
              <Text>{row.title}</Text>
              <Text style={styles.horizontalTableValue}>
                {row.renderValue(data)}
              </Text>
            </View>
          ) : null
        )}
        {Number.isFinite(totalRow) ? (
          <View style={styles.horizontalTableTotalRow}>
            <Text style={styles.horizontalTableTotalRowTitle}>
              {totalRowTitle}
            </Text>
            <Text
              style={{ ...styles.horizontalTableValue, marginLeft: "auto" }}
            >
              {formatMoney(totalRow)}
            </Text>
          </View>
        ) : null}
      </View>
    </View>
  );
}

export default PDFHorizontalTable;
